export default ({ request }) => ({
  ecomEvgSkuPlatformListingListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/listing',
      method: 'post',
      data,
    })
  },
  ecomEvgSkuPlatformPutShelvesApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/putShelves',
      method: 'post',
      data,
    })
  },
  ecomEvgSkuPlatformListingDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/listing/detail',
      method: 'post',
      data,
    })
  },
  ecomEvgSkuPlatformListingSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/listing/save',
      method: 'post',
      data,
    })
  },
  ecomEvgSkuPlatformUnsaleableApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/unsaleable',
      method: 'post',
      data,
    })
  },
  ecomEvgSkuPlatformAvailableSaleApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/availableSale',
      method: 'post',
      data,
    })
  },
  ecomEvgSkuPlatformCombineOptionsApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/combine/options',
      method: 'post',
      data,
    })
  },
})
